// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-6e4ab922]{border-collapse:collapse}table[data-v-6e4ab922],td[data-v-6e4ab922],th[data-v-6e4ab922]{border:.5px solid #000}.overflow-visible[data-v-6e4ab922]{white-space:normal;overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
